import { QuestionBase } from './question-base.model';

export class InclusionExclusion extends QuestionBase<string> {
    controlType = 'inclusion-exclusion';
    type: string;
    resourcelist: any;
    reload:any;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.resourcelist = options['resourcelist'] || [];
        this.reload = "";
    }
}